<template>
    <el-container :class="{'floating-layer':true,'Overlay': Overlay,'floating-layer-pc': !ismobile,'floating-layer-mobile': ismobile}" v-if="floatingShow" :style="{'width': diaWidth}">
         <transition>
           <div :class="{'popDiaContent':true,'slide-in': visible,'slide-out': !visible}">
             <div class="head">
               <img class="iconNotice" src="/static/img/noPayOrderPop/notice.png" />
               <span class="title">{{$t('continueFinishBook')}} - {{orderDetail.orderno}}</span>
               <img class="close_button" src="/static/img/noPayOrderPop/close.png" @click="close" v-if="!Overlay"/>
             </div>
             <div class="hotelInfo">
               <img class="hotelInfoImg" :src="hotelDetail.pic_path"/>
               <span class="HotelInfoName">{{hotelDetail.hotelname}}</span>
             </div>
             <div class="orderInfo">
               <div class="contentRow">
                 {{orderDetail.roomcount}} {{$t('间')}} {{orderDetail.night}} {{$t('夜')}}
               </div>
               <div class="contentRow">
                 {{orderDetail.checkin}} - {{orderDetail.checkout}}
               </div>
             </div>
             <div class="button">
               <div class="CancelBookingBtn" @click="jumpPay(orderDetail.orderno, orderDetail.waitingPayData, 'cancel')">
                 {{$t('CancelBooking')}}
               </div>
               <div class="completeBookingBtn" @click="jumpPay(orderDetail.orderno, orderDetail.waitingPayData, 'complete')">
                 {{$t('CompleteBooking')}}
               </div>
             </div>
           </div>
         </transition>
      <publicMask :fullscreenLoading="Overlay"></publicMask>
    </el-container>
</template>

<script>
import { getNoPayOrderDetail } from '@/request/order.js'
import publicMask from '@/components/public/publicMask'
export default {
  name: 'NoPayOrderPop',
  props: ['Overlay', 'onlyCheckHotelId', 'hotelId'],
  components: {
    getNoPayOrderDetail,
    publicMask
  },
  data () {
    return {
      ismobile: false,
      diaWidth: '402px',
      visible: false,
      floatingShow: false,
      orderDetail: {'orderno': '', 'source': '', 'roomcount': '1', 'night': '1', 'currency': 'USD', 'totalprice': '', 'parent_room_en': '', 'checkin': '2024年5月15日', 'checkout': '2024年5月16日', 'waitingPayData': ''},
      hotelDetail: {'hotelname': '', 'pic_path': ''},
      currency: this.common.currencySet(this),
      language: this.common.languageSet(this)
    }
  },
  watch: {},
  created () {},
  mounted () {
    if (document.documentElement.clientWidth < 1001) {
      this.ismobile = true
      this.diaWidth = '94%'
    } else {
      this.ismobile = false
      this.diaWidth = '402px'
    }
    this.noPayOrderPop()
  },
  methods: {
    open () {
      this.visible = true
      this.floatingShow = true
    },
    close () {
      this.visible = false
      let time = parseInt(new Date().getTime() / 1000)
      localStorage.setItem('noPayOrderPop_' + this.$route.name, time.toString())
      setTimeout(() => {
        this.floatingShow = false
      }, 1000)
      // 埋点日志记录
      let logData = {
        'orderno': this.orderDetail.orderno,
        'action': 'close'
      }
      this.clickPageAction('pop-up', 'pop-up-close', logData)
    },
    noPayOrderPop () {
      let time = parseInt(new Date().getTime() / 1000)
      console.log('noPayOrderPop_' + this.$route.name)
      let showPopTime = localStorage.getItem('noPayOrderPop_' + this.$route.name)
      if (showPopTime !== null && time - parseInt(showPopTime) < 1800) {
        return ''
      }
      let hotelId = this.common.linkQuerys.hotelid !== undefined ? this.common.linkQuerys.hotelid : this.hotelId
      let type = this.common.linkQuerys.type
      let typeid = this.common.linkQuerys.type_id
      let token = localStorage.getItem('token')
      if (token === undefined || token === null || token === '') {
        return ''
      }
      var dataJson = {
        'operation': 'noPayPop',
        'hotelid': hotelId !== undefined ? hotelId : '',
        'type': type !== undefined ? type : '',
        'typeid': typeid !== undefined ? typeid : '',
        'time': time,
        'token': token,
        'onlyCheckHotelId': this.onlyCheckHotelId ? '1' : '',
        'language': this.language
      }
      let data = this.common.encryptionData(dataJson, this)
      getNoPayOrderDetail(data).then(res => {
        if (res.flag === '200' && res.data.orderDetail) {
          this.orderDetail = res.data.orderDetail
          this.hotelDetail = res.data.hotelDetail
          this.open()
        }
        return res
      }).then(res => {
        if (res.data.orderDetail && res.data.orderDetail.orderno) {
          this.$nextTick(() => {
            // 埋点日志记录
            let logData = {
              'orderno': res.data.orderDetail.orderno
            }
            this.clickPageAction('pop-up', 'pop-up-show', logData, data, res)
          })
        }
      })
    },
    jumpPay (orderno, waitingPayData, action) {
      localStorage.setItem('orderData', JSON.stringify(waitingPayData))
      sessionStorage.setItem('productStr', waitingPayData.product)
      sessionStorage.setItem('hotelQuotedPriceSesstionId', waitingPayData.sesstionid)
      let actionString = 'pop-up-' + action
      // 埋点日志记录
      let logData = {
        'orderno': orderno,
        'action': actionString
      }
      this.clickPageAction('pop-up', actionString, logData)
      // this.$router.push({name: 'WritePay', query: { 'orderno': orderno, 'source': waitingPayData.source, 'showCancel': '1' }})
      var newQuerys = this.common.linkEncode({ 'orderno': orderno, 'source': waitingPayData.source, 'showCancel': '1' }, 'obj')
      if (waitingPayData.conver === 1 || waitingPayData.conver === '1') {
        newQuerys = this.common.linkEncode({ 'orderno': orderno, 'source': waitingPayData.source, 'showCancel': '1', 'conver': waitingPayData.conver }, 'obj')
      }
      this.$router.push({name: 'WritePay', params: {'querys': newQuerys}})
    }
  },
  computed: {}
}
</script>

<style scoped>
.floating-layer {
  position: fixed;
  display: flex;
  justify-content: flex-end;
  z-index: 10000;
}

.floating-layer-pc {
  top: 18px;
  right: 0;
}

.floating-layer-pc.Overlay {
  top: calc((100vh - 228px) / 2) !important;
  right: calc((100vw - 402px) / 2) !important;
}

.floating-layer-mobile {
  bottom: 0;
  right: 3%;
}

.floating-layer-mobile.Overlay {
  top: calc((100vh - 228px) / 2) !important;
}

.popDiaContent {
  width: 100%;
  height: 228px;
  position: relative;
  border-radius: 8px;
  background-color: #FFFFFF;
  box-sizing: border-box;
  box-shadow: 5px 5px 8px 0 rgba(0,0,0,0.35);
  padding: 10px 10px 10px 10px;
  animation-duration: 1s;
  animation-fill-mode: forwards;
}

.floating-layer-pc .popDiaContent {
  padding: 11px 19px 11px 19px !important;
}

/*pc端右侧划动效果*/
.floating-layer-pc:not(.Overlay) .slide-in {
  animation-name: slide-in-right;
}

.floating-layer-pc:not(.Overlay) .slide-out {
  animation-name: slide-out-right;
}

/*移动端底部划动效果*/
.floating-layer-mobile:not(.Overlay) .slide-in {
  animation-name: slide-in-bottom;
}

.floating-layer-mobile:not(.Overlay) .slide-out {
  animation-name: slide-out-bottom;
}

@keyframes slide-in-right {
  0% {
    right: -402px;
  }
  100% {
    right: 45px;
  }
}

@keyframes slide-out-right {
  0% {
    right: 45px;
  }
  100% {
    right: -402px;
  }
}

@keyframes slide-in-bottom {
  0% {
    bottom: -228px;
  }
  100% {
    bottom: 10px;
  }
}

@keyframes slide-out-bottom {
  0% {
    bottom: 10px;
  }
  100% {
    bottom: -228px;
  }
}

.head {
  width: 100%;
  height: 30px;
  display: flex;
  align-items: center;
  margin-bottom: 7px;
}

.title {
  /*font-size: 16px;*/
  font-size: 0.9rem;
  background-color: rgba(255, 255, 255, 0);
  box-sizing: border-box;
  font-family: 'PingFangSC-Medium', 'PingFang SC Medium', 'PingFang SC', sans-serif;
  font-weight: 500;
  color: #333333;
  text-align: left;
  line-height: 22px;
  margin-left: 5px;
}

.iconNotice {
  width: 24px;
  height: 24px;
  box-sizing: border-box;
}

.close_button {
  width: 30px;
  height: 30px;
  box-sizing: border-box;
  cursor: pointer;
  position: absolute;
  right: 10px;
}

.floating-layer-pc .close_button {
  right: 19px !important;
}

.hotelInfo {
  /*width: 100%;*/
  height: 67px;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.hotelInfoImg {
  width: 100px;
  height: 67px;
  box-sizing: border-box;
}

.HotelInfoName {
  /*font-size: 16px;*/
  font-size: 0.9rem;
  width: 265px;
  height: 67px;
  background-color: rgba(255, 255, 255, 0);
  box-sizing: border-box;
  font-family: 'PingFangSC-Regular', 'PingFang SC', sans-serif;
  color: #333333;
  text-align: left;
  line-height: normal;
  margin-left: 5px;
}

.contentRow {
  /*font-size: 14px;*/
  font-size: 0.75rem;
  width:100%;
  background-color: rgba(255, 255, 255, 0);
  box-sizing: border-box;
  font-family: 'PingFangSC-Regular', 'PingFang SC', sans-serif;
  color: #333333;
  text-align: left;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-bottom: 10px;
}

.button {
  width: 100%;
  height: 35px;
  display: flex;
  align-items: center;
  flex-direction: column-reverse;
  flex-wrap: wrap;
  -ms-flex-align: center;
  -webkit-box-orient: vertical;
  -webkit-box-direction: reverse;
  -ms-flex-direction: column-reverse;
  -ms-flex-wrap: wrap;
  align-content: space-between;
}

.CancelBookingBtn {
  width: 165px;
  height: 35px;
  border-radius: 6px;
  border: 1px solid #aaaaaa;
  background-color: #ffffff;
  box-sizing: border-box;
  font-family: 'PingFangSC-Medium', 'PingFang SC Medium', 'PingFang SC', sans-serif;
  font-size: 0.9rem;
  font-weight: 500;
  color: #4f4c4c;
  text-align: center;
  line-height: 35px;
  margin-right: 10px;
  cursor: pointer;
}

.CancelBookingBtn:hover {
  background-color: #4f4c4c;
  box-sizing: border-box;
  color: #fcd205;
}

.CancelBookingBtn:active {
  background-color: #fcd205;
  box-sizing: border-box;
  color: #4f4c4c;
}

.completeBookingBtn {
  width: 165px;
  height: 35px;
  /*font-size: 14px;*/
  font-size: 0.9rem;
  line-height: 33px;
  border-radius: 6px;
  border: 1px solid #fcd205;
  background-color: #fcd205;
  box-sizing: border-box;
  font-family: 'PingFangSC-Medium', 'PingFang SC Medium', 'PingFang SC', sans-serif;
  font-weight: 500;
  color: #4f4c4c;
  text-align: center;
  cursor: pointer;
}

.completeBookingBtn:hover {
  background-color: #4f4c4c;
  box-sizing: border-box;
  color: #fcd205;
}

.completeBookingBtn:active {
  background-color: #fcd205;
  box-sizing: border-box;
  color: #4f4c4c;
}

</style>



// WEBPACK FOOTER //
// src/components/order/module/NoPayOrderPop.vue